module.exports = __webpack_public_path__ + "img/company4-1.31e94045.png";